import { fetcher } from "utils";

export const post__member__auth__password = (params: {
  email: string;
}): Promise<"비밀번호 재설정 안내 메일이 발송되었습니다."> => fetcher.post("/members/auth/password", params);
